var _rect, _line, _path, _line2, _polygon, _polygon2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateValve({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gate Valve") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 8.06,
    x2: 4.23,
    y2: 8.06,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.91,8.06",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8.06,
    x2: 11.72,
    y2: 8.06,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4.27 6.21 4.27 9.92 7.98 8.06 4.27 6.21",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.72 6.21 11.72 9.92 8.01 8.06 11.72 6.21",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.01,
    y1: 5.16,
    x2: 8.01,
    y2: 8.06,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.74,
    y1: 5.16,
    x2: 9.27,
    y2: 5.16,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateValve);
export default __webpack_public_path__ + "static/media/GateValve.71f4c4d627c0ba2967b67f68ad3ec4d8.svg";
export { ForwardRef as ReactComponent };